// src/components/SelectedPhotosPage.js
import React, { useState, useEffect } from "react";
import logoFacomLong from "./../../images/LOGOFACOMLONG.png";
import logoFacomSquare from "./../../images/LOGOFACOMSQUARE.png";
import gainsImg from "./../../images/GarageLego.png";
import "./Looser.css";

const Looser = () => {
  return (
    <div className="header">
      <div className="logo">
        <img src={logoFacomLong} />
      </div>
      <div className="title">
        <div className="headerTitle">Perdu !</div>
        <div className="underTitle">Une deuxième chance ?</div>
        <div className="underTitle">
          Créez votre compte client sur <a href="https://facom.fr">facom.fr</a>{" "}
          pour intégrer notre programme de fidélité et gagner d'autres cadeaux !
        </div>
      </div>
      <div className="footerInfos">
        <div
          className="secondChance"
          onClick={() =>
            window.open("https://www.facom.fr/account/login", "_blank")
          }
        >
          JE CRÉE MON COMPTE ET JE RETENTE MA CHANCE
          <img src={logoFacomSquare} />
        </div>
      </div>
    </div>
  );
};

export default Looser;
